import type { QueryClient, QueryKey } from "@tanstack/react-query";

export type CmtsLifecycleDomain = "complaint" | "rca" | "capa" | "verification";

/**
 * Canonical mutation refresh fan-out. Lifecycle mutations affect more than their
 * local grid: complaint detail, timeline, work queues, closure readiness,
 * dashboards, tasks and calendar projections are all derived consumers.
 */
export async function invalidateCmtsLifecycleMutation(
  queryClient: QueryClient,
  complaintId: string,
  domain: CmtsLifecycleDomain,
): Promise<void> {
  const keys: readonly QueryKey[] = [
    ["cmts", domain, complaintId],
    ["cmts", domain, "queue"],
    ["cmts", "complaint", complaintId],
    ["cmts", "complaints"],
    ["cmts", "complaint-detail", complaintId],
    ["cmts", "timeline", complaintId],
    ["cmts", "closure-readiness", complaintId],
    ["cmts", "dashboard"],
    ["cmts", "dashboards"],
    ["cmts", "tasks"],
    ["cmts", "calendar"],
    ["cmts", "notifications"],
    ["cmts", "reports"],
  ];
  await Promise.all(keys.map((queryKey) => queryClient.invalidateQueries({ queryKey })));
}
